export enum IncomingStatisticsParameters {
  From = 'From',
  To = 'To',
  ClinicIds = 'ClinicIds',
}
